document.addEventListener('DOMContentLoaded', function() {
  // Entferne Produkttext aus Quantity Input
  const quantityInputs = document.querySelectorAll('.quantity__input');
  
  quantityInputs.forEach(input => {
    // Entferne aria-label (enthält Produkttext)
    input.removeAttribute('aria-label');
    
    // Setze Placeholder auf leer
    input.setAttribute('placeholder', '');
    
    // Entferne value wenn es Produkttext enthält
    if (input.value && isNaN(input.value)) {
      input.value = '1';
    }
    
    // Verhindere dass Text eingefügt wird
    input.addEventListener('input', function(e) {
      // Nur Zahlen erlauben
      this.value = this.value.replace(/[^0-9]/g, '');
      
      // Mindestens 1
      if (this.value === '' || parseInt(this.value) < 1) {
        this.value = '1';
      }
    });
    
    // Entferne Produkttext beim Focus
    input.addEventListener('focus', function() {
      if (isNaN(this.value)) {
        this.value = '1';
      }
    });
    
    // Entferne Produkttext beim Blur (wenn Feld verlassen wird)
    input.addEventListener('blur', function() {
      if (this.value === '' || isNaN(this.value) || parseInt(this.value) < 1) {
        this.value = '1';
      }
    });
  });
});
